import classNames from 'classnames';
import React, { FC, useState } from 'react';
import {ReactComponent as Info} from 'assets/svgs/info.svg'
import {ReactComponent as Close} from 'assets/svgs/clear.svg'
import { Popover } from 'antd';

type Props = {
    label?: string;
    wrapperClassName?: string;
    className?: string;
    info?: string;
    infoClassName?: string;
    hideText?: boolean;
};

const OnahLabel: FC<Props> = ({label, className, wrapperClassName, info, infoClassName, hideText}) => {
    const [open, setOpen] = useState(false);

    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    };
    
    return (label ? (
        <div className={classNames(wrapperClassName, 'flex items-center  2xl:mb-[12px] mb-[8px]')}>
            <label className={classNames('font-semibold 2xl:text-[18px] text-[14px] block text-black flex-1', className, hideText ? 'opacity-0' : '')}>{label}</label>
            {info && (
                <Popover 
                    trigger="click" 
                    content={<p style={{lineBreak: 'anywhere'}} className="-mt-5 max-w-[90%] text-white text-[14px] font-sans">{info}</p>} 
                    open={open}
                    color="#4A4B4C"
                    overlayClassName="w-[253px]"
                    autoAdjustOverflow
                    arrowPointAtCenter={false}
                    placement="topLeft"
                    onOpenChange={handleOpenChange}
                    title={<div className='flex justify-end'><Close color='white' onClick={hide}/></div>}>
                    <Info className={classNames('text-black ml-1',infoClassName)}/>
                </Popover>
            )} 
        </div>
    ): null)
};

export default OnahLabel;